import { ContextMenuItem, ContextMenuSeparator } from '@cad-arc';

export function ItemsWithSeparators({
    itemGroups,
}: {
    itemGroups: React.ReactElement[][];
}): React.ReactElement {
    const groupsWithElements = itemGroups.filter((group) => group.length > 0);
    if (groupsWithElements.length === 0) {
        return <ContextMenuItem isDisabled={true}>No options available</ContextMenuItem>;
    }

    const itemsWithSeparators = groupsWithElements.flatMap((group, index) => {
        return index < groupsWithElements.length - 1
            ? [...group, <ContextMenuSeparator key={`separator-${index}`} />]
            : group;
    });
    return <>{itemsWithSeparators}</>;
}
